<div class="modelContainer alignCenter">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle heading2">
    {{data.title}}
  </div>
  <div class="modelBody">
    <div *ngIf="(data.success)">
      <div class="icon"><img src="../../../assets/svg/Success.svg" alt="Success" /></div>
    </div>
    <div *ngIf="!(data.success)">
      <div class="icon"><img src="../../../assets/svg/Error.svg" alt="Failure" /></div>
    </div>
    <div class="sureMsg">{{data.message}}</div>
  </div>
</div>

